/**
 * Tải một Blob về máy người dùng.
 *
 * Các endpoint xuất file của service trả stream (`responseType: 'blob'`), nên `await` xong là đã
 * có dữ liệu trong tay — nhưng nếu không tự dựng link thì **không có file nào rơi xuống máy**,
 * trong khi màn hình vẫn báo thành công. Đó là chế độ hỏng tệ nhất: người dùng tin là đã xuất
 * được. Mọi nút xuất file phải đi qua đây.
 *
 * `views/helpers/downloadFileFromData.js` không dùng lại được: nó làm
 * `new Blob(['﻿' + getData()])` nên một Blob truyền vào sẽ bị stringify thành
 * `"[object Blob]"`.
 */
export const downloadBlob = (blob, filename) => {
    if (!blob) throw new Error('Không nhận được dữ liệu file từ hệ thống')

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.download = filename
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

/** Hậu tố thời điểm xuất cho tên file: `20260910-1745`. */
export const exportStamp = (date = new Date()) => {
    const pad = (value) => String(value).padStart(2, '0')

    return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`
        + `-${pad(date.getHours())}${pad(date.getMinutes())}`
}
